module.exports = "/fonts/vendor/quasar-extras/roboto-web-KFOlCnqEu92Fr1MmSU5fBBc-.woff?a1471d1d6431c893582a5f6a250db3f9";


//////////////////
// WEBPACK FOOTER
// ./node_modules/quasar-extras/roboto-font/web-font/KFOlCnqEu92Fr1MmSU5fBBc-.woff
// module id = n2n3
// module chunks = 49